export const sendWidgetMessage = (message) => {
  if (!window?.parent) {
    return;
  }
  window.parent.postMessage(message, '*')
}
